
import { mapState, mapGetters } from 'vuex';
import ReviewSource from '@/enums/ReviewSource';

export default {
  name: 'AppReviewUserInfoSectionUserDisplay',
  props: {
    review: {
      type: Object,
      required: true
    },
    authorColor: {
      type: String,
      default: 'gray100',
      validator: v => ['gray100', 'white'].includes(v)
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('reviewSettings', [
      'isAuthorDisplayTypeUserGrade',
      'isAuthorDisplayTypeAuthorType'
    ]),
    userType() {
      if (this.review.my_review) return this.$t('my_review');
      else if (
        this.review.review_source === ReviewSource.MANAGER &&
        this.reviewSettings.show_staff_review_info
      )
        return this.$t('staff_review');
      return '';
    }
  }
};
